var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _activeTrigger, _onSubDrawerOpen, _onCartNoteClose, _onClick;
import { C as Component, k as CustomEvents, Y as trapFocus, Z as removeTrapFocus, _ as SubDrawerOpenEvent } from "./utilities-Da0sjanJ.js";
class SubDrawer extends Component {
  constructor() {
    super();
    __publicField(this, "requiredRefs", ["subDrawerContent"]);
    __privateAdd(this, _activeTrigger, null);
    __privateAdd(this, _onSubDrawerOpen, (event) => {
      const { targetId } = event.detail;
      if (this.id !== targetId) return;
      this.openSubDrawer();
    });
    __privateAdd(this, _onCartNoteClose, () => {
      this.closeSubDrawer();
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CustomEvents.cartNoteUpdate, __privateGet(this, _onCartNoteClose));
    document.addEventListener(CustomEvents.subDrawerOpen, __privateGet(this, _onSubDrawerOpen));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CustomEvents.cartNoteUpdate, __privateGet(this, _onCartNoteClose));
    document.removeEventListener(CustomEvents.subDrawerOpen, __privateGet(this, _onSubDrawerOpen));
  }
  openSubDrawer() {
    var _a;
    const { subDrawerContent, subDrawerCloseButton } = this.refs;
    subDrawerContent.classList.add("open");
    this.classList.add("open");
    (_a = this.closest("dialog")) == null ? void 0 : _a.classList.add("sub-drawer-active");
    subDrawerCloseButton.setAttribute("aria-expanded", "true");
    trapFocus(this);
  }
  closeSubDrawer() {
    var _a;
    const { subDrawerContent, subDrawerCloseButton } = this.refs;
    if (subDrawerContent.classList.contains("open")) {
      subDrawerContent.classList.remove("open");
      this.classList.remove("open");
    }
    (_a = this.closest("dialog")) == null ? void 0 : _a.classList.remove("sub-drawer-active");
    subDrawerCloseButton.setAttribute("aria-expanded", "false");
    removeTrapFocus();
  }
}
_activeTrigger = new WeakMap();
_onSubDrawerOpen = new WeakMap();
_onCartNoteClose = new WeakMap();
class SubDrawerTrigger extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onClick, () => {
      const targetId = this.dataset.target;
      if (!targetId) return;
      document.dispatchEvent(new SubDrawerOpenEvent(targetId, this));
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", __privateGet(this, _onClick));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", __privateGet(this, _onClick));
  }
}
_onClick = new WeakMap();
if (!customElements.get("sub-drawer")) {
  customElements.define("sub-drawer", SubDrawer);
}
if (!customElements.get("sub-drawer-trigger")) {
  customElements.define("sub-drawer-trigger", SubDrawerTrigger);
}
